import React from "react";
import { Switch } from "@headlessui/react";

interface ToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  label?: string;
  size?: "xs" | "sm" | "md" | "lg";
}

export const Toggle: React.FC<ToggleProps> = ({ enabled, onChange, label, size = "md" }) => {
  const sizeClasses = {
    xs: "h-3 w-6",
    sm: "h-4 w-7",
    md: "h-5 w-9",
    lg: "h-6 w-11",
  };

  const thumbSizeClasses = {
    xs: "h-2 w-2",
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const translateClasses = {
    xs: "translate-x-3",
    sm: "translate-x-3",
    md: "translate-x-4",
    lg: "translate-x-5",
  };

  return (
    <div className="flex items-center">
      <Switch
        checked={enabled}
        onChange={onChange}
        className={`${
          enabled ? "bg-desert-sand-400" : "bg-gray-200"
        } relative inline-flex ${sizeClasses[size]} items-center rounded-full`}
      >
        <span className="sr-only">Enable {label}</span>
        <span
          className={`${
            enabled ? translateClasses[size] : "translate-x-0.5"
          } inline-block ${thumbSizeClasses[size]} transform rounded-full bg-white transition`}
        />
      </Switch>
      {label && <span className="ml-2 text-sm">{label}</span>}
    </div>
  );
};
